exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.jsoneditor-frame {\n  display: none !important;\n}\n.modal-content {\n  width: 600px\n}\n.jsoneditor-vue {\n  height: 250px !important\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?{"minimize":false,"sourceMap":false}!./~/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-d3209e08","scoped":false,"hasInlineConfig":false}!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/views/beast/workflows/Index.vue
// module id = 864
// module chunks = 1